import showMessage from "./common/showMessage";
const handleRequestFail = (reservationForm) => (responseBody) => {
    var _a, _b;
    (_a = reservationForm.querySelector("input[type='submit']")) === null || _a === void 0 ? void 0 : _a.classList.remove("loading");
    (_b = reservationForm.querySelector("input[type='submit']")) === null || _b === void 0 ? void 0 : _b.removeAttribute("disabled");
    if (responseBody === "email is not valid") {
        showMessage.error(document.getElementById("reservation-email-input"), "メールアドレスが不正です。打ち間違えてないかどうかご確認していただくか、別のアドレスをご入力ください。");
    }
    else {
        showMessage.error(reservationForm, "フォーム送信中にエラーが発生しました。<br>再度お試しください。");
    }
};
export default handleRequestFail;
